import React, { useEffect, useState } from 'react';
import { Users, Ticket } from 'lucide-react';
import { motion } from 'framer-motion';
interface UrgencyBannerProps {
  coupons: number;
  viewers: number;
}
export function UrgencyBanner({
  coupons,
  viewers
}: UrgencyBannerProps) {
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        setIsSticky(rect.top <= 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <motion.div initial={false} animate={{
      y: isSticky ? 0 : -100,
      opacity: isSticky ? 1 : 0
    }} className="py-2 fixed top-0 left-0 w-full z-50 shadow-2xl border-b border-white/20 bg-white/10 backdrop-blur-2xl" data-id="element-256" data-mp="3b6y1os1hqve6">
        <div className="max-container px-4 flex flex-wrap justify-center items-center text-xs font-black uppercase tracking-tighter gap-[10px]" data-id="element-257" data-mp="1gwc8kjdq652u">
          <div className="flex text-[12px] font-[700] font-sans gap-[8px] flex-row items-center justify-start text-purple-950" data-id="element-258" data-mp="22nq48orm70md">
            <span className="relative flex h-2 w-2" data-id="element-259" data-mp="1xpg8aby2fvzp">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75" data-id="element-260" data-mp="1sq3nrxuo310a"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-261" data-mp="2qcj42wbcxsm9"></span>
            </span>
            <Users size={14} className="text-purple-600" data-id="element-262" data-mp="2lfspkdf7b52y" />
            {viewers} PERSONAS MIRANDO
          </div>
          <div className="flex items-center gap-2 font-[700] text-[12px] text-purple-950" data-id="element-263" data-mp="2gdtkmz3tc03w">
            <span className="relative flex h-2 w-2" data-id="element-264" data-mp="2cd9nvwn5iyia">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-265" data-mp="14zzlbtt7t7av"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-266" data-mp="10ye827crqr05"></span>
            </span>
            <Ticket size={14} className="text-purple-600" data-id="element-267" data-mp="12gupbhqbln7t" />
CUPONES DE DESCUENTO: {coupons}
          </div>
        </div>
      </motion.div>
    </>;
}